import { PromotersRequestsModule } from '@/modules/promoters/requests';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { AccessDenied } from '../../../../components/ui/access-denied';
import { useAccessControl } from '../../../../hooks/useAccessControl';

const searchSchema = z.object({
  page: z.number().catch(1),
  limit: z.number().catch(10),
  search: z.string().optional(),
});

export const Route = createFileRoute('/dashboard/promoters/requests/')({
  validateSearch: searchSchema,
  component: PromotersRequestsPage,
});

function PromotersRequestsPage() {
  const { canAccessPromoterProfile } = useAccessControl();

  if (!canAccessPromoterProfile) {
    return <AccessDenied />;
  }

  return <PromotersRequestsModule />;
}
